// TODO: Move this code into the module when ni.js is deprecated

(function($) {
    $.fn.exclusivePopover = function(config) {
        var el = $(this);



        config = config || {};
        config.trigger  = config.trigger || 'show.bs.popover';

        function hide () {
            if (el.data('bs.popover')) {
                el.popover('hide');
            }
            if (config.onHide) {
                config.onHide.call(el);
            }
        }

        el.data('exclusivePopoverGroup', config.group);

        // close when click on another popover
        $(document).on(config.trigger, function (event) {

            if (
                event.target === el[0] ||
                el.has(event.target).length ||
                ($(event.target).data('exclusivePopoverGroup') !== config.group && config.group !== undefined)
            ) {
                return;
            }
            hide();
        });

        // close when outer click
        $(document).on('click', 'html', function (event) {

            if (event.target === el[0] || el.has(event.target).length) {
                return;
            }

            var popup;

            if (el.data('exclusive_popover')) {
                popup = el.data('exclusive_popover').$tip;
            }
            if (!popup && el.data('bs.popover')) {
                popup = el.data('bs.popover').$tip;
            }

            if (!popup || event.target === popup[0] || popup.has(event.target).length) {
                return;
            }

            hide(el);
        });

        return el;
    };

})(jQuery);
